import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { FormCheckBox } from '@ami/react/core';
//import './AuthorizedDealerBranchSettingCard.scss';

const AuthorizedDealerBranchSettingCard = ({
  dealerBranchSetting,
  permissions,
  dealerBranchSettingChange,
  unauthorizeDealerBranchClick,
  showRetiredBadge,
}) => {
  const onPermissionChange = (checked, permissionValue) => {
    if (checked) {
      const permission = permissions.dealerBranch.find(
        (x) => x.value === permissionValue
      );
      dealerBranchSetting.permissions = [
        ...dealerBranchSetting.permissions,
        permission.value,
      ];
      dealerBranchSettingChange(dealerBranchSetting, true);
    } else {
      var index = dealerBranchSetting.permissions.indexOf(permissionValue);
      dealerBranchSetting.permissions = [
        ...dealerBranchSetting.permissions.slice(0, index),
        ...dealerBranchSetting.permissions.slice(index + 1),
      ];
      dealerBranchSettingChange(dealerBranchSetting, true);
    }
  };

  return (
    <div className="col-12 col-md-4">
      <div className="dealerBranchSetting-card card mb-3">
        <div className="card-header">
          <div className="clearfix">
            <h5 className="pull-left mb-0">{dealerBranchSetting.name}</h5>
            {showRetiredBadge && (
              <span className="badge text-bg-danger ms-3">Retired</span>
            )}
            {unauthorizeDealerBranchClick && (
              <button
                type="button"
                className="pull-right btn btn-link p-1"
                onClick={() =>
                  unauthorizeDealerBranchClick(
                    dealerBranchSetting.dealerBranchId
                  )
                }
              >
                remove
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="row form-group">
            <div className="col-12">
              <label className="form-label">Role</label>
              <div>
                <ButtonGroup>
                  <Button
                    color="primary"
                    onClick={() =>
                      dealerBranchSettingChange(
                        {
                          ...dealerBranchSetting,
                          isAdministrator: true,
                        },
                        true
                      )
                    }
                    active={dealerBranchSetting.isAdministrator}
                  >
                    Admin
                  </Button>
                  <Button
                    color="primary"
                    onClick={() =>
                      dealerBranchSettingChange(
                        {
                          ...dealerBranchSetting,
                          isAdministrator: false,
                        },
                        true
                      )
                    }
                    active={!dealerBranchSetting.isAdministrator}
                  >
                    User
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className="row form-group">
            <div className="col-12">
              <label className="form-label">Permissions</label>
              {permissions.dealerBranch.map((permission) => (
                <div className="row" key={permission.value}>
                  <div className="col-12">
                    <FormCheckBox
                      className="mb-0"
                      checkboxLabel={permission.description}
                      disabled={dealerBranchSetting.isAdministrator}
                      onChange={(e) => onPermissionChange(e, permission.value)}
                      checked={
                        dealerBranchSetting.isAdministrator ||
                        dealerBranchSetting.permissions.some(
                          (x) => x === permission.value
                        )
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AuthorizedDealerBranchSettingCard.defaultProps = {
  dealerBranchSetting: { isAdministrator: false, permissions: [] },
};

AuthorizedDealerBranchSettingCard.propTypes = {
  dealerBranchSetting: PropTypes.object,
  permissions: PropTypes.object.isRequired,
  dealerBranchSettingChange: PropTypes.func.isRequired,
  unauthorizeDealerBranchClick: PropTypes.func,
  showRetiredBadge: PropTypes.bool,
};

export default AuthorizedDealerBranchSettingCard;
